import { Box, Typography } from "@mui/material";
import AgentFooterStyles from "./AgentFooterStyles";
import {
  PRIVACY_POLICY,
  RESERVED_RIGHTS,
  TERMS_AND_SERVICES,
} from "../../constants";

const AgencyFooter = () => {
  return (
    <Box sx={AgentFooterStyles.footerContainer}>
      <Typography sx={AgentFooterStyles.copyRights}>
        © {new Date().getFullYear()} Smart IMS. All rights reserved.
      </Typography>
      <Box sx={AgentFooterStyles.footerItems}>
        <Typography sx={AgentFooterStyles.rightText}>
          {TERMS_AND_SERVICES}
        </Typography>
        <Typography sx={AgentFooterStyles.rightText}>
          {PRIVACY_POLICY}
        </Typography>
      </Box>
    </Box>
  );
};

export default AgencyFooter;
